<template>
  <div class="apply-induction">
    <b-button
      variant="primary"
      class="ml-1 mt-1"
      :disabled="loading"
      @click="dialogShow = true"
    >
      {{ $t('_apply.induction.passInterviewUserSelect') }}
    </b-button>

    <template v-if="!initLoading">
      <my-form
        v-if="option.columns"
        ref="formRef"
        :data="data"
        :dataCody="dataCody"
        :loading="loading"
        :option="option"
        width="auto"
        :footer-visible="false"
        @submit="handleSubmit"
      />
      <!-- submit and reset -->
      <div class="cc-footer">
        <b-button
          variant="outline-primary"
          :disabled="loading"
          @click="saveDrafts"
        >
          {{ $t('_components.btns.saveDrafts') }}
        </b-button>
        <b-button variant="primary" :disabled="loading" @click="send">
          {{ $t('_components.btns.send') }}
        </b-button>
      </div>
    </template>

    <!-- 通过面试人员选择 -->
    <c-modal
      :header="false"
      :footer="false"
      :visible="dialogShow"
      @close="dialogShow = false"
    >
      <template slot="content">
        <div>
          <b-form-group :label="$t('_apply.induction.nric')">
            <b-form-input
              v-model="interviewUserForm.nric"
              :placeholder="$t('_apply.induction.nric')"
            />
          </b-form-group>
          <b-form-group :label="$t('_apply.induction.name')">
            <b-form-input
              v-model="interviewUserForm.enName"
              :placeholder="$t('_apply.induction.name')"
            />
          </b-form-group>

          <div class="text-right">
            <b-button
              variant="primary"
              class="mb-1"
              :disabled="loading"
              @click="handleUserSelectChange"
            >
              {{ $t('_components.btns.search') }}
            </b-button>
          </div>

          <b-list-group class="interview-user-container">
            <b-list-group-item
              v-for="(item, i) in interviewUsers"
              :key="i"
              class="d-flex"
              @click="handleUserSelect(item)"
            >
              <span class="mr-1">
                <b-avatar
                  size="sm"
                  :src="item.photoAttach ? item.photoAttach.link : ''"
                />
              </span>
              <span>
                {{ item.enName }}&nbsp; {{ item.nric }}&nbsp;
                {{ item.email }}&nbsp;
              </span>
            </b-list-group-item>
          </b-list-group>
        </div>
      </template>
    </c-modal>
    <c-modal
      title="message"
      :visible="showSSOMsg"
      :message="ssoMsg"
      @close="() => (showSSOMsg = false)"
      @modelConfirm="modelConfirmSSO"
    />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BFormGroup,
  BFormInput,
  BListGroupItem,
  BListGroup,
  BAvatar,
} from 'bootstrap-vue'
import MyForm from '@/components/myForm/index.vue'
import applyAPI from '@/api/apply/index'
import templateFormAPI from '@/api/templateForm/index'
import { templateFormat, templateSubmitFormat } from '@/util/func'
import website from '@/config/website'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapGetters } from 'vuex'
import inductionAPI from '@/api/apply/induction'
import CModal from '@/components/crud/modal.vue'
import { deepClone } from '@/util/util'
import { indexOf } from 'lodash'
import interviewAPI from '@/api/staff/interview/index'
import projectAPI from '@/api/base/project'
import { getDeptListTree } from '@/api/system/dept'
import { getList as getPostList } from '@/api/system/post'
export default {
  components: {
    MyForm,
    BRow,
    BCol,
    BButton,
    CModal,
    BFormGroup,
    BFormInput,
    BListGroupItem,
    BListGroup,
    BAvatar,
  },
  props: {
    processKey: {
      type: String,
      default: undefined,
    },
    explain: {
      type: String,
      default: undefined,
    },
    processId: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      formId: '6',
      loading: false,
      showSSOMsg: false,
      ssoMsg: 'ss',
      dialogShow: false,
      hasDept: false,
      projectList: [],
      postList: [],
      data: {
        IsCreateItRequestForm: '1',
      },
      deptList: [],
      dataCody: {},
      ssoForm: {},
      columns: [],
      interviewUserForm: {
        nric: '',
        enName: '',
        status: 1,
      },
      interviewUsers: [],
      initLoading: false,
    }
  },

  mounted() {
    this.project()
    this.getDept()
    this.setPostList()
    this.onLoad(this.formId)
  },
  computed: {
    ...mapGetters(['userAllInfo', 'dictsStaticData']),
    companyId() {
      return (
        this.userAllInfo.staffInfo.companyId ||
        this.userAllInfo.workerInfo.companyId
      )
    },
    option() {
      const columns = []
      const { deptId, IsCreateItRequestForm } = this.data
      this.columns.forEach((item) => {
        const dictQuery = item.formOption.dictQuery || {}
        const temp = item
        if (item.formOption.dictCode === 'dept') {
          dictQuery.parentId = this.companyId
          this.hasDept = true
        }
        if (item.formOption.dictCode === 'post') {
          dictQuery.deptId = deptId
          temp.disabled = !deptId
          temp.formOption.small =
            this.$t('_components.placeholder.firstInput') +
            this.i18n('labelEmployment.deptId')
        }

        if (item.field === 'description') {
          item.formOption.hide = true
          item.hide = true
        }
        if (item.field === 'projectId' || item.field === 'dateRequired') {
          item.formOption.hide = IsCreateItRequestForm != 1
          item.hide = IsCreateItRequestForm != 1
        }

        temp.formOption.dictQuery = dictQuery

        columns.push(temp)
      })
      const option = {
        columns,
      }

      return option || {}
    },
  },
  methods: {
    // i18n
    i18n(param) {
      return this.$t(`_staff.${param}`)
    },
    async setPostList() {
      getPostList(1, -1).then((res) => {
        if (res.data.code === 200) {
          this.postList = res.data.data.records
        }
      })
    },
    async getDept() {
      const res = await getDeptListTree(2, '1123598813738675201')
      if (res.data.code === 200) {
        this.deptList = res.data.data
        console.log(this.findNameById('1437234799424688130'), '部门name')
      }
    },
    findPostName(id) {
      let obj = {}
      this.postList.forEach((item) => {
        if (item.id === id) {
          obj = item
        }
      })
      return obj.postName || ''
    },
    findNameById(targetId) {
      let obj = {}
      this.deptList.forEach((item) => {
        if (item.id === targetId) {
          obj = item
        } else if (item.children) {
          item.children.forEach((child) => {
            if (child.id === targetId) {
              obj = child
            }
          })
        }
      })

      return obj.deptName || ''
    },
    async project(params = {}) {
      const res = await projectAPI.getList(1, -1, params)
      const temp = res.data.data.records.concat({
        projectName: 'N/A',
        id: '0',
      })
      const result = temp.map((el) => ({
        label: el.projectName,
        value: el.id,
      }))
      this.projectList = result
    },

    onLoad(formId) {
      if (this.processId) {
        applyAPI.detail({ id: this.processId }).then((res) => {
          this.data = res.data.data.map
          const mobileObj = this.extractPhoneNumber(this.data.mobile)
          this.data.mobile = mobileObj.phoneNumber
          this.data.mobileCode = mobileObj.areaCode
          this.dataCody = deepClone(this.data)
        })
      }
      templateFormAPI.detail({ formId }).then((res) => {
        const temp = res.data.data.records
        const result = []
        temp.forEach((item) => {
          const t = item
          if (
            [
              'photo',
              'confirmFile',
              'fileIds',
              'latestPayslip',
              'trainingCertificate',
              'highestQualificationCert',
              'nricFile',
            ].indexOf(item.fieldName) !== -1
          ) {
            t.fieldName = `${item.fieldName}Files`
          }
          result.push(t)
        })
        this.columns = templateFormat(result) // , setDictQuery)
      })
    },
    modelConfirmSSO() {
      const router = website.staffProcessRouter
      const startIndex = this.ssoMsg.indexOf('[')
      const endIndex = this.ssoMsg.indexOf(']')
      const employeeCode = this.ssoMsg.substring(startIndex + 1, endIndex)
      const params = this.ssoForm
      params.originalStaffNo = employeeCode || ''
      applyAPI.saveAndStart(params, router[params.formId]).then((res) => {
        this.$emit('close')
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
      })
    },
    handleSubmit(forms) {
      const form = deepClone(forms)
      console.log(form, '表单数据')
      form.staffNo = form.staffNo.trim()
      form.mobile = `${form.mobileCode} ${form.mobile}`

      const params = templateSubmitFormat(form, this.columns)
      params.processKey = this.processKey
      params.formId = this.formId
      const router = website.staffProcessRouter
      if (form.IsCreateItRequestForm != 1) {
        params.description = ''
        params.dateRequired = ''
        params.projectId = ''
      } else {
        console.log(this.findNameById(form.deptId), '部门名称')
        console.log(this.findPostName(form.postId), '岗位名称')
        const FindDeptName = this.findNameById(form.deptId)
        const FindPostName = this.findPostName(form.postId)
        const projectName = this.projectList.filter(
          (item) => item.value == params.projectId
        )

        let description = {
          Category: 'IT Hardware',
          Description: `${params.staffNo}-${params.enName}-${projectName?.[0]
            ?.label || 'NA'}-${FindDeptName}/${FindPostName}-${moment(
            params.dateRequired
          ).format('DD/MM/YYYY')}-${params.email}`,
          Quantity: '1',
          id: 1,
        }
        params.description = JSON.stringify([description])
      }

      this.loading = false

      if (this.hasDept) {
        params.companyId = this.companyId
      }
      if (this.isDrafts) {
        this.loading = true
        if (this.processId) {
          applyAPI
            .edit({
              ...params,
              processId: this.processId,
              processKey: this.processKey,
              formId: this.formId,
            })
            .then((res) => {
              this.$emit('close')
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('_default.toast.title'),
                  icon: 'BellIcon',
                  text: this.$t('_default.toast.text.success'),
                  variant: 'success',
                },
              })
              this.loading = false
            })
        } else {
          applyAPI.add(params, router[params.formId]).then((res) => {
            this.$emit('close')
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('_default.toast.title'),
                icon: 'BellIcon',
                text: this.$t('_default.toast.text.success'),
                variant: 'success',
              },
            })
            this.loading = false
          })
        }
      } else {
        this.loading = true
        if (this.processId) {
          applyAPI
            .edit({
              ...params,
              processId: this.processId,
              processKey: this.processKey,
              formId: this.formId,
            })
            .then((res) => {
              applyAPI
                .start({ processId: this.processId })
                .then(() => {
                  if (res.data.code === 10136) {
                    this.ssoForm = params
                    this.showSSOMsg = true
                    this.ssoMsg = res.data.msg
                  } else {
                    this.$emit('close')
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: this.$t('_default.toast.title'),
                        icon: 'BellIcon',
                        text: this.$t('_default.toast.text.success'),
                        variant: 'success',
                      },
                    })
                  }
                })
                .catch((err) => {
                  this.loading = false
                })
            })
            .catch((err) => {
              this.loading = false
            })
        } else {
          if (Number(params.formId) === 6) {
            console.log('这里')

            applyAPI.saveAndStart(params, router[params.formId]).then((res) => {
              if (res.data.code === 10136) {
                this.ssoForm = params
                this.showSSOMsg = true
                this.ssoMsg = res.data.msg
              } else {
                this.$emit('close')
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: this.$t('_default.toast.title'),
                    icon: 'BellIcon',
                    text: this.$t('_default.toast.text.success'),
                    variant: 'success',
                  },
                })
              }
            })
          } else {
            applyAPI.saveAndStart(params, router[params.formId]).then((res) => {
              this.$emit('close')
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('_default.toast.title'),
                  icon: 'BellIcon',
                  text: this.$t('_default.toast.text.success'),
                  variant: 'success',
                },
              })
            })
          }
        }
        console.log(Number(params.formId) === 6)
      }
    },
    send() {
      console.log('sssssss', this.$refs.formRef)
      if (
        this.$refs.formRef &&
        (this.$refs.formRef.showEmailDuplicated ||
          this.$refs.formRef.showMobileDuplicated ||
          this.$refs.formRef.showStaffNoDuplicated)
      ) {
        return
      }
      this.isDrafts = false
      this.$refs.formRef.validationForm()
    },
    saveDrafts() {
      this.isDrafts = true
      this.$refs.formRef.validationForm()
    },
    handleUserSelectChange() {
      console.log(this.interviewUserForm)
      if (this.interviewUserForm.nric || this.interviewUserForm.enName) {
        inductionAPI.getList(1, -1, this.interviewUserForm).then((res) => {
          this.interviewUsers = res.data.data.records
        })
      } else {
        this.interviewUsers = []
      }
    },
    extractPhoneNumber(str) {
      // 去除字符串首尾可能存在的空格
      str = str.trim()
      let plusSignRemoved = str
      // 如果字符串以 '+' 开头，去除 '+'
      if (str.startsWith('+')) {
        plusSignRemoved = str.slice(1)
      }
      // 正则匹配区号和手机号，假设区号和手机号都是数字，以空格分隔
      const match = plusSignRemoved.match(/^(\d+)\s+(\d+)$/)
      if (match) {
        return {
          areaCode: '+' + match[1],
          phoneNumber: match[2],
        }
      }
      // 如果没有匹配到区号和手机号的格式，直接返回手机号
      return {
        areaCode: '',
        phoneNumber: str,
      }
    },
    handleUserSelect(e) {
      this.initLoading = true
      interviewAPI
        .leaderInterviewDetail({ interviewId: e.interviewId })
        .then((res) => {
          this.data = e

          const mobileObj = this.extractPhoneNumber(this.data.mobile)
          this.data.mobile = mobileObj.phoneNumber
          this.data.mobileCode = mobileObj.areaCode

          this.data.salary = res.data.data.monthlySalary
          this.initLoading = false
          this.dialogShow = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.apply-induction {
  height: 100%;
  position: relative;
  margin: 0 !important;

  .my-form {
    height: calc(100% - 100px) !important;
    margin-bottom: 100px;
    position: relative;
    overflow: hidden;
    &_btns {
      left: 0;
      right: 0;
      position: absolute;
      bottom: 0;
      text-align: center;
      border-top: 1px solid #ebe9f1;
      background: #fff;
      padding: 1.5rem 0;
    }
  }
}
.cc-footer {
  width: 100%;
  position: absolute;
  bottom: 00px;
  padding: 20px 16px;
  background-color: #ffffff;
  display: flex;
  justify-content: right;
  gap: 16px;
}
</style>

<style lang="scss">
.modal-content {
  .interview-user-container {
    max-height: 200px;
    overflow: auto;
    .list-group-item {
      cursor: pointer;
    }
  }
}
</style>
